/**
 * Store state for wordpress/themes module
 */
import AppAPI from '@/api'

export const initialState = {
  colors: AppAPI.colors,
  css: '',
  navigation: null,
  sidebar: null,
  footer: null
}

const state = {...initialState}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/themes/state.js